import clsx from 'clsx';
import { Icon } from 'ui';
import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import useInputGrades from './useInputGrades';

const InputGrades = ({
  onChange,
  placeholder,
  type,
  disabled,
  referer,
  size,
  pointsTotal,
  isScoreReadOnly,
  max,
  min,
  showDotted,
  isLate,
  scoreScale,
  t,
  ...props
}) => {
  const { value, hasError, onChangeText, onFocus, onBlur } = useInputGrades({ props, max, onChange, scoreScale });

  return (
    <div className={clsx('input-points', { 'input-points--read-only': isScoreReadOnly }, `input-points--size-${size}`)}>
      <div className={clsx('input-points__input-container', { 'has-error': hasError }, { 'input-points__input-container--dotted': showDotted })}>
        <input
          className={clsx('input-points__input', { 'input-points__input--disabled': disabled })}
          type={type}
          placeholder={placeholder}
          onChange={onChangeText}
          onFocus={onFocus}
          onBlur={onBlur}
          disabled={disabled}
          ref={referer}
          readOnly={isScoreReadOnly}
          max={max}
          min={min}
          value={value}
        />
        {isLate && (
          <div className="input-points__late">
            <TooltipCustom title={t('lesson:Delivered late')} placement="top" hasArrow>
              <div>
                <Icon name="exclamation-circle" />
              </div>
            </TooltipCustom>
          </div>
        )}
        <label className="input-points__points-total">/{pointsTotal}</label>
      </div>
    </div>
  );
};

InputGrades.propTypes = {
  disabled: PropTypes.bool,
  isLate: PropTypes.bool,
  isScoreReadOnly: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  pointsTotal: PropTypes.number,
  referer: PropTypes.object,
  scoreScale: PropTypes.string,
  showDotted: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big', 'medium']),
  t: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

InputGrades.defaultProps = {
  type: 'text',
  disabled: false,
  pointsTotal: 10,
  size: 'default',
  showDotted: false,
  isLate: false,
};

export default InputGrades;
